import React from 'react';
import List from './List';

const NewList = ({ ...props }) => (
  <List
    url="installer-orders?order_status=unassigned"
    title="Unassigned Orders"
    canManage={true}
    {...props}
  />
);

export default NewList;



// WEBPACK FOOTER //
// ./src/pages/InstallerOrders/UnassignedList.js